import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15140334&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15140334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15140334')) {
      api.createRecord('15140334', component.options)
    } else {
      api.reload('15140334', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15140334&scoped=true", function () {
      api.rerender('15140334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/application/index.vue"
export default component.exports